<!--  -->
<template>
    <div>
        <van-nav-bar
            left-arrow
            fixed
            :title="$t('CustomerList.title')"
            @click-left="$router.go(-1)"/>
        <div v-if="phoneList.length>0" v-cloak>
            <!-- <van-cell :title="$t('phoneList.name')" :value="$t('phoneList.phone')"></van-cell>
            <van-cell v-for="(item,index) in phoneList" :key="index" :title="item.gender==0?item.name+'(女)':item.name+'(男)'" :value="item.phone" is-link @click="$router.push('/CustomerList/'+item.phone)"/> -->

            <van-cell-group>
                <van-cell>
                    <van-row>
                        <van-col span="10">{{$t('phoneList.name')}}</van-col>
                        <van-col span="10">{{$t('phoneList.phone')}}</van-col>
                        <van-col span="4">次数</van-col>
                    </van-row>
                    <div slot="right-icon" style="width: 22px;"></div>
                </van-cell>
                <template v-for="(item,index) in phoneList">
                    <van-cell center is-link v-if="item.phone" :to="{ path: '/CustomerList/'+item.phone}">
                        <van-row>
                            <van-col span="10">{{item.name}}</van-col>
                            <van-col span="10">{{item.phone}}</van-col>
                            <van-col span="4">{{item.number}}</van-col>
                        </van-row>
                    </van-cell>
                </template>
            </van-cell-group>

        </div>
        <div v-cloak  class="text">{{text}}</div>

    </div>
</template>

<script>
export default {
    data () {
        return {
            phoneList:[],
            text:''
        };
    },
    created(){
        this.getPhoneList();
    },
    methods:{
        getPhoneList(){
            this.$axios({
                method: 'get',
                headers: {
                    "Authorization": 'Bearer '+sessionStorage.token,
                },
                url: this.$build+'/api/store/'+sessionStorage.actShopId+'/phone',
            }).then(res => {
            	if(res.data.status==200){
                    console.log(res);
                    this.phoneList=res.data.data
                    if(this.phoneList.length<=0){
                        this.text = this.$t('CustomerList.noCustomer')
                    }
            	}else{
            		for (var item in res.data.error) {
            			this.$toast({
		            		type:'fail',
		            		message:res.data.error[item],
		            	});
            		}
            	}
            }).catch(err => {
            	this.$toast({
            		type:'fail',
            		message:this.$t('StaffList.message'),
        		});
            });
        }
    }
}

</script>
<style scoped>
    /deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	/deep/ .van-field__left-icon .van-icon{
		font-size: 20px;
	}
	/deep/ .van-cell .van-icon{
		font-size: 20px;
	}
    /deep/ .van-cell__value{
        color: #323233
    }
    [v-cloak] {
        display: none !important;
    }
    .text{
        text-align: center;
        margin-top: 10%;
        font-size: 30px;
    }
    .wrap{
        background: #fff;
        display: flex;
        justify-content: space-between;
        font-size: 18px;
        padding: 10px 16px;
        line-height: 24px;
        border-bottom: 1px solid #eee;
        height: 28px;
    }
</style>


// WEBPACK FOOTER //
// src/Shop/PhoneList.vue